import * as R from 'ramda'
// import { isValid, format } from "date-fns"


export default class SaveAddressRequest {
  constructor (billing = {}, shipping = {}) {
    this.billing = {
      address1: [
        R.is(String, billing.addressLine1) ? billing.addressLine1 : ""
      ],
      use_for_shipping : R.is(Boolean, billing.isShippingAddress) ? billing.isShippingAddress : "",
      first_name : R.is(String, billing.firstname) ? billing.firstname : "",
      last_name : R.is(String, billing.lastname) ? billing.lastname : "",
      email : R.is(String, billing.email) ? billing.email : "",
      city : R.is(String, billing.city) ? billing.city : "",
      state  : R.is(String, billing.state) ? billing.state : "",
      postcode : R.is(String, billing.zipCode) ? billing.zipCode : "",
      country : R.is(String, billing.country) ? billing.country : "",
      phone : R.is(String, billing.phone) ? billing.phone : "",
    },

    this.shipping = this.generateShipping(shipping)

 }

   generateShipping(shipping) {
     if (this.billing.use_for_shipping === false) {
       return {
         address1: [
           R.is(String, shipping.addressLine1) ? shipping.addressLine1 : ""
         ],
         first_name : R.is(String, shipping.firstname) ? shipping.firstname : "",
         last_name : R.is(String, shipping.lastname) ? shipping.lastname : "",
         email : R.is(String, shipping.email) ? shipping.email : "",
         city : R.is(String, shipping.city) ? shipping.city : "",
         state  : R.is(String, shipping.state) ? shipping.state : "",
         postcode : R.is(String, shipping.zipCode) ? shipping.zipCode : "",
         country : R.is(String, shipping.country) ? shipping.country : "",
         phone : R.is(String, shipping.phone) ? shipping.phone : "",
       };
     }
     return { address1: ["0"] }
  }

}
